<template>
  <div class="analysystable">
    <table>
      <tr class="cuneiform is-size-3" :class="cuneiformClass">
        <td
          v-for="sign in displaySigns"
          :key="sign.index"
          :colspan="sign.width"
          class="analysis_sign"
        >
          {{ sign.sign }}
        </td>
      </tr>
      <tr>
        <td
          v-for="element in analysisResult"
          :key="element.id"
          :colspan="element.width"
        >
          {{ display(element.value) }}
        </td>
      </tr>
      <template v-for="(row, rowIndex) in picklist">
        <tr :key="rowIndex">
          <template v-for="(col, colIndex) in row">
            <td v-if="col === 0" :key="colIndex"></td>
            <template v-else-if="col === 1"></template>
            <td v-else :key="colIndex" :colspan="col.width">
              <b-button
                class="button--pick"
                expanded
                size="is-small"
                :class="{ 'is-info': col.selected }"
                @click="readingPick(rowIndex, colIndex)"
              >
                {{ display(col.value) }}
              </b-button>
            </td>
          </template>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
const SyllablesTable = require("@/data/syllables_table_.json");

import DisplayTransLiteral from "../modules/Transliteral.js";

//ulength returns number of codepoints of str
function ulength(str) {
  return Array.from(str).length;
}

export default {
  data() {
    return {
      picklist: [],
    };
  },

  props: {
    text: String,
    level: {
      type: Number,
      default: 1,
    },
    cuneiformClass: {
      type: String,
      default: "akkadian",
    },
    transliteralStyle: String,
  },
  mounted() {
    this.pickListMake();
    this.updateResult();
  },
  methods: {
    updateResult() {
      this.$emit("change-result", this.selectedSigns);
    },
    pickListClear() {
      this.picklist = [];
    },
    pickListPushItem(col, item, length) {
      var row = 0;
      for (;;) {
        if (this.picklist.length <= row) {
          this.picklist.push(new Array(this.textSigns.length).fill(0));
        }

        if (this.picklist[row].slice(col, col + length).every((x) => x == 0)) {
          this.picklist[row].splice(col, 1, {
            value: item,
            selected: false,
            column: col,
            id: item + "_" + row + "_" + col,
            dummy: false,
            width: length,
          });
          for (var i = 1; i < length; i++) {
            this.picklist[row].splice(col + i, 1, i);
          }
          break;
        }
        row = row + 1;
      }
    },
    //候補リストの作成
    pickListMake() {
      this.pickListClear();

      for (var i = 0; i < this.textSigns.length; i++) {
        let sign = this.textSigns[i];
        let lst = this.signs[sign];

        if (lst) {
          var found = false;
          for (let key in lst) {
            let l = ulength(key);
            let fragment = this.textSigns.slice(i, i + l).join("");

            if (key === fragment) {
              for (let n = 0; n <= this.level; n++) {
                let transliterals = lst[key].transliteral[n];

                for (let index in transliterals) {
                  found = true;
                  this.pickListPushItem(i, transliterals[index], l);
                }
              }
            }
          }
          if (!found) {
            this.pickListPushItem(i, lst[sign].name, 1);
          }
          if (this.picklist[0][i]) {
            this.picklist[0][i].selected = true;
          }
        }
      }
    },
    pickOff(colIndex) {
      for (var i = 0; i < this.picklist.length; i++) {
        let pick = this.picklist[i][colIndex];
        if (pick === 0) {
          //
        } else if (Number(pick) >= 1) {
          let pick2 = this.picklist[i][colIndex - pick];
          if (pick2.selected) {
            this.pickOff(colIndex - pick);
          }
        } else {
          pick.selected = false;
        }
      }
    },
    readingPick(rowIndex, colIndex) {
      let pick = this.picklist[rowIndex][colIndex];
      let selected = pick.selected;
      this.pickOff(colIndex);
      if (!selected) {
        for (let index = 1; index < pick.width; index++) {
          this.pickOff(colIndex + index);
        }
        pick.selected = true;
      }
    },
    display(str) {
      return DisplayTransLiteral(str, this.transliteralStyle);
    },
  },
  computed: {
    signs() {
      return SyllablesTable.signs;
    },
    displaySigns() {
      //複数の符号で1文字になる読みが選択されているときは楔形文字の表示も連結したいので、
      //textSignsを分割しなおす
      let result = [];
      let analysisResult = this.analysisResult.filter((x) => !x.dummy);
      let i2 = 0;
      for (let i1 = 0; i1 < this.textSigns.length; ) {
        const element = this.textSigns[i1];
        const pick = analysisResult[i2];

        if (!pick || i1 < pick.column) {
          result.push({
            sign: element,
            col: i1,
            width: 1,
          });
          i1++;
        } else if (i1 === pick.column) {
          result.push({
            sign: this.textSigns.slice(i1, i1 + pick.width).join(""),
            col: i1,
            width: pick.width,
          });
          i2++;
          i1 += pick.width;
        } else {
          //ここにはこないはず
          i1++;
        }
      }
      return result;
    },
    textSigns() {
      if (this.text === "") return [];
      return Array.from(this.text);
    },
    selectedSigns() {
      var id = 0;
      let result = [];
      if (this.picklist.length == 0) return result;
      for (let col = 0; col < this.picklist[0].length; col++) {
        for (let row = 0; row < this.picklist.length; row++) {
          const element = this.picklist[row][col];
          if (element.selected) {
            result.push(element);
          }
        }
      }
      return result;
    },
    analysisResult() {
      let result = [];
      let col = 0;
      this.selectedSigns.forEach((element) => {
        if (col < element.column) {
          result.push({
            value: "",
            selected: true,
            column: col,
            id: "dummy" + col,
            dummy: true,
            width: element.column - col,
          });
        }
        result.push(element);
        col = element.column + element.width;
      });
      return result;
    },
  },

  watch: {
    text(newText, oldText) {
      this.pickListMake();
    },
    level(newLevel, oldLevel) {
      this.pickListMake();
    },
    selectedSigns() {
      this.updateResult();
    },
  },
};
</script>

<style lang="sass">
.analysystable
    overflow-x: auto
    white-space: nowrap
    -webkit-overflow-scrolling: touch
    th,td
        min-width: 50px
.analysis_sign
  letter-spacing: 0px
</style>
